const QUERIES = {
  mobile: 'screen and (max-width: 1023px)',
  desktop: 'screen and (min-width: 1024px)'
}

export default QUERIES



// WEBPACK FOOTER //
// ./src/styles/config/queries.js